module.exports = __webpack_public_path__ + "img/abacus_type_2.89d49389.png";